import Phaser from "phaser";
import { FIGHTER } from "../config";

/**
 * UMK-style health bar:
 *  - чёрная подложка с золотой рамкой
 *  - градиентная заливка (жёлтый → оранжевый → красный по убыванию HP)
 *  - имя бойца над полосой
 *  - анимация «danger flash» когда HP < 20%
 */
export class HealthBar {
  scene: Phaser.Scene;
  bg: Phaser.GameObjects.Rectangle;
  border: Phaser.GameObjects.Rectangle;
  fill: Phaser.GameObjects.Rectangle;
  label: Phaser.GameObjects.Text;
  width: number;
  height: number;
  reverse: boolean;
  private flashTween?: Phaser.Tweens.Tween;
  private dangerFlashing = false;

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    width: number,
    label: string,
    reverse = false,
  ) {
    this.scene = scene;
    this.width = width;
    this.height = 22;
    this.reverse = reverse;

    // золотая внешняя рамка
    this.border = scene.add.rectangle(x, y, width + 6, this.height + 6, 0xffd700)
      .setOrigin(reverse ? 1 : 0, 0.5);

    // чёрная подложка
    this.bg = scene.add.rectangle(x + (reverse ? -3 : 3), y, width, this.height, 0x1a0505)
      .setOrigin(reverse ? 1 : 0, 0.5);

    // заливка (динамический цвет в update)
    this.fill = scene.add.rectangle(x + (reverse ? -3 : 3), y, width, this.height - 2, 0xffd700)
      .setOrigin(reverse ? 1 : 0, 0.5);

    this.label = scene.add.text(x + (reverse ? -3 : 3), y - 22, label.toUpperCase(), {
      fontFamily: "Arial Black",
      fontSize: "18px",
      color: "#ffffff",
      stroke: "#c41e3a",
      strokeThickness: 4,
    }).setOrigin(reverse ? 1 : 0, 0.5);
  }

  update(hp: number, hpMax: number = FIGHTER.HP_MAX) {
    const pct = Math.max(0, hp) / hpMax;
    this.fill.width = this.width * pct;

    // Цвет: золото → оранж → красный
    if (pct > 0.6)      this.fill.fillColor = 0xffd700;
    else if (pct > 0.3) this.fill.fillColor = 0xff8800;
    else                this.fill.fillColor = 0xff2020;

    // Danger flash когда HP < 20% (как «FINISH HIM»-индикатор)
    const danger = pct > 0 && pct < 0.2;
    if (danger && !this.dangerFlashing) {
      this.dangerFlashing = true;
      this.flashTween = this.scene.tweens.add({
        targets: this.border,
        alpha: { from: 1, to: 0.3 },
        duration: 250,
        yoyo: true,
        repeat: -1,
      });
    } else if (!danger && this.dangerFlashing) {
      this.dangerFlashing = false;
      this.flashTween?.stop();
      this.border.setAlpha(1);
    }
  }
}
